import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getVariantList = createAsyncThunk(
  "get-variant",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("variant/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteVariant = createAsyncThunk(
  "delete-variant",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/variant/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const variantSlice = createSlice({
  name: "variant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariantList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVariantList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.variantList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getVariantList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default variantSlice.reducer;
